import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { RoutePath } from '../../constants';
import { REACT_APP_CONTEXT_PATH } from '../../config';

import PropTypes from 'prop-types';
import AuthError from '../AuthError';
import ConsentConfirmation from '../ConsentConfirmation';
import EligibleVehicle from '../EligibleVehicle';
import ErrorPage from '../ErrorPage';
import Login from '../Login';
import Logout from '../Logout';
import Version from '../Version';
import { getQueryParamString } from '../../util';

const UnauthenticatedAppRoutes = ({ onSignIn, error, redirecting, account }) => {
  return (
    <Switch>
      <Route exact path={RoutePath.version} render={() => <Version />} />
      <Route exact path={RoutePath.authError} render={(props) => <AuthError {...props} />} />
      <Route exact path={RoutePath.login} render={() => <Login login={onSignIn} error={error} account={account} />} />
      <Route path='*' render={() => (redirecting ? <div>Redirecting...</div> : <Redirect to={RoutePath.login} />)} />
    </Switch>
  );
};

const AuthenticatedAppRoutes = ({ tokenResp, account, onSignOut, eligibleVehResp, setEligibleVehResp, spinnerRef }) => {
  return (
    <Switch>
      <Route exact path={RoutePath.version} render={() => <Version />} />
      <Route
        exact
        path={RoutePath.eligibleVehicle}
        render={() => (
          <EligibleVehicle
            tokenResp={tokenResp}
            account={account}
            eligibleVehResp={eligibleVehResp}
            setEligibleVehResp={setEligibleVehResp}
            spinnerRef={spinnerRef}
          />
        )}
      />
      <Route
        exact
        path={RoutePath.consentConfirmation}
        render={() => <ConsentConfirmation eligibleVehResp={eligibleVehResp} spinnerRef={spinnerRef} />}
      />
      <Route exact path={RoutePath.authError} render={(props) => <AuthError {...props} />} />
      <Route exact path={RoutePath.error} render={() => <ErrorPage />} />
      <Route exact path={RoutePath.logout} render={() => <Logout onSignOut={onSignOut} />} />
      <Route path={RoutePath.root}>
        <Redirect to={{ pathname: RoutePath.eligibleVehicle, search: getQueryParamString() }} />
      </Route>
    </Switch>
  );
};

const AppRoute = ({
  authenticated,
  onSignIn,
  onSignOut,
  tokenResp,
  account,
  redirecting,
  error,
  accessToken,
  eligibleVehResp,
  setEligibleVehResp,
  spinnerRef,
}) => {
  return (
    <BrowserRouter basename={REACT_APP_CONTEXT_PATH}>
      {authenticated ? (
        <AuthenticatedAppRoutes
          tokenResp={tokenResp}
          account={account}
          onSignOut={onSignOut}
          eligibleVehResp={eligibleVehResp}
          setEligibleVehResp={setEligibleVehResp}
          spinnerRef={spinnerRef}
        />
      ) : (
        <UnauthenticatedAppRoutes onSignIn={onSignIn} error={error} redirecting={redirecting} account={account} />
      )}
    </BrowserRouter>
  );
};

AppRoute.propTypes = {
  accessToken: PropTypes.object,
  authenticated: PropTypes.bool,
  account: PropTypes.object,
  error: PropTypes.string,
  onSignIn: PropTypes.func,
  onSignOut: PropTypes.func,
  signUp: PropTypes.func,
  redirecting: PropTypes.bool,
  tokenResp: PropTypes.object,
  eligibleVehResp: PropTypes.object,
  setEligibleVehResp: PropTypes.func,
  spinnerRef: PropTypes.object,
};

export default AppRoute;
